import { useAxiosQuery } from 'hooks/useAxiosQuery';
import { useParams } from 'react-router-dom';
import { PROJECT_CACHE_KEY } from 'services/queryKeys';
import { Project } from 'types';

export function ProjectBreadcrumb() {
  const { projectSlug = '' } = useParams();

  const { data = [] as Project[] } = useAxiosQuery<Project>(
    PROJECT_CACHE_KEY(projectSlug),
    `/projects/my-projects/?external_identifier__eq=${projectSlug}`
  );
  const project = data?.[0] ?? {};

  return project?.name ?? projectSlug;
}
